import MVGRVoices from "../../assets/images/projects/MVGRvoices.png";
import moderndictionary from "../../assets/images/projects/moderndictionary.png";
import mathtime from "../../assets/images/projects/mathtime.png";
const MyProjects = [
    {
        id:1,
        name:"MVGR Voices",
        url:"https://mvgrvoices.onrender.com",
        logo:MVGRVoices,
        description:"A dynamic online platform encouraging students to express their ideas,stories & experiences through podcasts and blogs. This Project achieved a milestone of over 2000 users from our college."
    },
    {
        id:2,
        name:"MathTime",
        url:"https://kalyani179.github.io/MathTime/",
        logo:mathtime,
        description:"A web app focused on improving calculation abilities, featuring a versatile calculator, random quizzes, and engaging animations, sounds, and effects for an interactive learning experience."
    },
    {
        id:3,
        name:"ModernDictionary",
        url:"https://moderndictionary.onrender.com/",
        logo:moderndictionary,
        description:"A user-friendly web app designed to enhance English vocabulary, grammar skills, offering word definitions, examples, related words, and a 'word-of-the-day' section with real-time data from Wordnik API."
    },
]

export default MyProjects;